const TRANSFERS_TYPE = [
    { value: 0, label: 'Private', name: 'PRIVATE' },
    { value: 1, label: 'SIC', name: 'SIC' },
    { value: 2, label: 'Ticket only', name: 'TICKETS_ONLY' },
    { value: 3, label: 'Self Booked', name: 'SELF_BOOKED', disabled: true }
];

const ROASTER_DAY = [
    { value: 0, label: 'Sunday', name: 'Sunday' },
    { value: 1, label: 'Monday', name: 'Monday' },
    { value: 2, label: 'Tuesday', name: 'Tuesday' },
    { value: 3, label: 'Wednesday', name: 'Wednesday' },
    { value: 4, label: 'Thursday', name: 'Thursday' },
    { value: 5, label: 'Friday', name: 'Friday' },
    { value: 6, label: 'Saturday', name: 'Saturday' },
    { value: 7, label: 'All', name: 'All' }
];

const ROASTER_TIME = [
    { value: 0, label: 'Morning', name: 'Morning' },
    { value: 1, label: 'AfterNoon', name: 'AfterNoon' },
    { value: 2, label: 'Evening', name: 'Evening' },
    { value: 3, label: 'Half Day', name: 'Half_day' },
    { value: 4, label: 'Full Day', name: 'Full_day' },
    { value: 5, label: 'All', name: 'All' }
];
const SEND_OFFLINE_COMPONENT_KEY_IN = ['hotel_and_sightseeings'];
export { ROASTER_TIME, ROASTER_DAY, TRANSFERS_TYPE, SEND_OFFLINE_COMPONENT_KEY_IN };
